import React from 'react'

import { Col, Form } from '_zari/core'

const MontoDiferenciasFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='&ensp;' htmlFor='input-suma-montoDiferencias' md={12} />
      <Col md={12}>
        <Form.InputNumber
          id='input-suma-montoDiferencias'
          name='input-suma-montoDiferencias'
          className='text-danger'
          isInvalid
          disabled
          value={iValue}
          onChange={() => {}}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoDiferenciasFormGroup)
